import { DaoService } from "./DaoService";

export class MembreAffaireService extends DaoService {

    static CLASS_NAME = "App\\Models\\MembreAffaire";
    
    static getInstance() {
        return super.getInstance('membreaffaire');
    }

    all() {
        return MembreAffaireService.get(`${this.prefix}/all`);
    }

    search(data) {
        return MembreAffaireService.post(`${this.prefix}/search`, data);
    }

}